            <!-- Content Wrapper Start -->
            <div class="fm-content-wrapper">
                <div class="container-fluid">
                    <!-- Filter Section Start --> 
                    <div class="row">
                        <div class="col-12">
                            <div class="row align-items-center">
                                <div class="col-sm">
                                    <!-- Page Title -->
                                    <div class="fm-page-title">
                                        <h2 class="fm-head-24 fm-title mb-2">Storybooks</h2>
                                        <p class="mb-0">Create beautiful books from your life stories to share and treasure</p>
                                    </div>
                                </div>
                                <div class="col-auto mb-4 mb-sm-0">
                                    <a href="create-storybook.html" class="fm-common-btn">
                                        <img src="images/icons/fm-plus-large.svg" class="fm-svg" alt="Plus Icon" />
                                        Create Storybook
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Filter Section End -->  
                    <!-- Story Book Section Start -->
                    <div class="row g-3">
                        <div class="col-sm-6 col-lg-4 col-xxl-3">
                            <div class="fm-stories-blog fm-match-height">
                                <div class="fm-stories-cover">
                                    <img class="fm-image" src="images/storybooks/bookcover-1.png" alt="Book Cover Image">
                                </div>
                                <div class="fm-stories-content">
                                    <div class="fm-st-promt-tag">
                                        <span class="fm-st-ti">Childhood</span>
                                        <div class="fm-question-actions fm-dropdown ms-auto">
                                            <button type="button" class="fm-question-menu-btn" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Open storybook actions">
                                                <img src="images/icons/fm-vertical-dots.svg" class="fm-svg" alt="Actions" />
                                            </button>
                                            <div class="dropdown-menu fm-dropdown-menu">
                                                <a href="#" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-edit-pen.svg" class="fm-svg" alt="Edit" />
                                                    <span class="fm-question-action-label">Edit</span>
                                                </a>
                                                <button type="button" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-delete-bl.svg" class="fm-svg" alt="Delete" />
                                                    <span class="fm-question-action-label">Delete</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <h4 class="fm-head-20 fm-head-sty2 mb-0"><a href="storybook-details.html">Life’s Journey</a></h4>
                                    <p>A heartfelt story of love and memories that shaped life.</p>
                                    <div class="fm-user-profile">
                                        <hr class="my-0" />
                                        <div class="fm-card-btm">
                                            <p class="fm-icon-content">
                                            <img src="images/icons/fm-calendar-green.svg" class="fm-family-icon" alt="Calendar Icon" /> 
                                            May 12, 2024
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 col-xxl-3">
                            <div class="fm-stories-blog fm-match-height">
                                <div class="fm-stories-cover">
                                    <img class="fm-image" src="images/storybooks/bookcover-2.png" alt="Book Cover Image">
                                </div>
                                <div class="fm-stories-content">
                                    <div class="fm-st-promt-tag">
                                        <span class="fm-st-ti">Childhood</span>
                                        <div class="fm-question-actions fm-dropdown ms-auto">
                                            <button type="button" class="fm-question-menu-btn" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Open storybook actions">
                                                <img src="images/icons/fm-vertical-dots.svg" class="fm-svg" alt="Actions" />
                                            </button>
                                            <div class="dropdown-menu fm-dropdown-menu">
                                                <a href="#" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-edit-pen.svg" class="fm-svg" alt="Edit" />
                                                    <span class="fm-question-action-label">Edit</span>
                                                </a>
                                                <button type="button" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-delete-bl.svg" class="fm-svg" alt="Delete" />
                                                    <span class="fm-question-action-label">Delete</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <h4 class="fm-head-20 fm-head-sty2 mb-0"><a href="storybook-details.html">Memories with Grandpa</a></h4>
                                    <p>Beautiful moments and wisdom shared with Grandpa forever.</p>
                                    <div class="fm-user-profile">
                                        <hr class="my-0" />
                                        <div class="fm-card-btm">
                                            <p class="fm-icon-content">
                                            <img src="images/icons/fm-calendar-green.svg" class="fm-family-icon" alt="Calendar Icon" /> 
                                            April 28, 2024
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 col-xxl-3">
                            <div class="fm-stories-blog fm-match-height">
                                <div class="fm-stories-cover">
                                    <img class="fm-image" src="images/storybooks/bookcover-3.png" alt="Book Cover Image">
                                </div>
                                <div class="fm-stories-content">
                                    <div class="fm-st-promt-tag">
                                        <span class="fm-st-ti">Childhood</span>
                                        <div class="fm-question-actions fm-dropdown ms-auto">
                                            <button type="button" class="fm-question-menu-btn" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Open storybook actions">
                                                <img src="images/icons/fm-vertical-dots.svg" class="fm-svg" alt="Actions" />
                                            </button>
                                            <div class="dropdown-menu fm-dropdown-menu">
                                                <a href="#" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-edit-pen.svg" class="fm-svg" alt="Edit" />
                                                    <span class="fm-question-action-label">Edit</span>
                                                </a>
                                                <button type="button" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-delete-bl.svg" class="fm-svg" alt="Delete" />
                                                    <span class="fm-question-action-label">Delete</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <h4 class="fm-head-20 fm-head-sty2 mb-0"><a href="storybook-details.html">The Best of Dad</a></h4>
                                    <p>A touching tribute to Dad’s love, care, and guidance.</p>
                                    <div class="fm-user-profile">
                                        <hr class="my-0" />
                                        <div class="fm-card-btm">
                                            <p class="fm-icon-content">
                                            <img src="images/icons/fm-calendar-green.svg" class="fm-family-icon" alt="Calendar Icon" /> 
                                            June 16, 2024
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 col-xxl-3">
                            <div class="fm-stories-blog fm-match-height">
                                <div class="fm-stories-cover">
                                    <img class="fm-image" src="images/storybooks/bookcover-4.png" alt="Book Cover Image">
                                </div>
                                <div class="fm-stories-content">
                                    <div class="fm-st-promt-tag">
                                        <span class="fm-st-ti">Major Life Moment</span>
                                        <div class="fm-question-actions fm-dropdown ms-auto">
                                            <button type="button" class="fm-question-menu-btn" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Open storybook actions">
                                                <img src="images/icons/fm-vertical-dots.svg" class="fm-svg" alt="Actions" />
                                            </button>
                                            <div class="dropdown-menu fm-dropdown-menu">
                                                <a href="#" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-edit-pen.svg" class="fm-svg" alt="Edit" />
                                                    <span class="fm-question-action-label">Edit</span>
                                                </a>
                                                <button type="button" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-delete-bl.svg" class="fm-svg" alt="Delete" />
                                                    <span class="fm-question-action-label">Delete</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <h4 class="fm-head-20 fm-head-sty2 mb-0"><a href="storybook-details.html">Adventures That Made Us</a></h4>
                                    <p>Memorable adventures and journeys shared together always.</p>
                                    <div class="fm-user-profile">
                                        <hr class="my-0" />
                                        <div class="fm-card-btm">
                                            <p class="fm-icon-content">
                                            <img src="images/icons/fm-calendar-green.svg" class="fm-family-icon" alt="Calendar Icon" /> 
                                            July 08, 2024
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 col-xxl-3">
                            <div class="fm-stories-blog fm-match-height">
                                <div class="fm-stories-cover">
                                    <img class="fm-image" src="images/storybooks/bookcover-5.png" alt="Book Cover Image">
                                </div>
                                <div class="fm-stories-content">
                                    <div class="fm-st-promt-tag">
                                        <span class="fm-st-ti">Childhood</span>
                                        <div class="fm-question-actions fm-dropdown ms-auto">
                                            <button type="button" class="fm-question-menu-btn" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Open storybook actions">
                                                <img src="images/icons/fm-vertical-dots.svg" class="fm-svg" alt="Actions" />
                                            </button>
                                            <div class="dropdown-menu fm-dropdown-menu">
                                                <a href="#" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-edit-pen.svg" class="fm-svg" alt="Edit" />
                                                    <span class="fm-question-action-label">Edit</span>
                                                </a>
                                                <button type="button" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-delete-bl.svg" class="fm-svg" alt="Delete" />
                                                    <span class="fm-question-action-label">Delete</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <h4 class="fm-head-20 fm-head-sty2 mb-0"><a href="storybook-details.html">Lessons from Mom</a></h4>
                                    <p>Life lessons and warm memories learned from Mom always.</p>
                                    <div class="fm-user-profile">
                                        <hr class="my-0" />
                                        <div class="fm-card-btm">
                                            <p class="fm-icon-content">
                                            <img src="images/icons/fm-calendar-green.svg" class="fm-family-icon" alt="Calendar Icon" /> 
                                            May 10, 2024
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 col-xxl-3">
                            <div class="fm-stories-blog fm-match-height">
                                <div class="fm-stories-cover">
                                    <img class="fm-image" src="images/storybooks/bookcover-6.png" alt="Book Cover Image">
                                </div>
                                <div class="fm-stories-content">
                                    <div class="fm-st-promt-tag">
                                        <span class="fm-st-ti">Childhood</span>
                                        <div class="fm-question-actions fm-dropdown ms-auto">
                                            <button type="button" class="fm-question-menu-btn" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Open storybook actions">
                                                <img src="images/icons/fm-vertical-dots.svg" class="fm-svg" alt="Actions" />
                                            </button>
                                            <div class="dropdown-menu fm-dropdown-menu">
                                                <a href="#" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-edit-pen.svg" class="fm-svg" alt="Edit" />
                                                    <span class="fm-question-action-label">Edit</span>
                                                </a>
                                                <button type="button" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-delete-bl.svg" class="fm-svg" alt="Delete" />
                                                    <span class="fm-question-action-label">Delete</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <h4 class="fm-head-20 fm-head-sty2 mb-0"><a href="storybook-details.html">Daddy’s Little Buddy</a></h4>
                                    <p>Special childhood memories shared with a loving father.</p>
                                    <div class="fm-user-profile">
                                        <hr class="my-0" />
                                        <div class="fm-card-btm">
                                            <p class="fm-icon-content">
                                            <img src="images/icons/fm-calendar-green.svg" class="fm-family-icon" alt="Calendar Icon" /> 
                                            August 21, 2024
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 col-xxl-3">
                            <div class="fm-stories-blog fm-match-height">
                                <div class="fm-stories-cover">
                                    <img class="fm-image" src="images/storybooks/bookcover-7.png" alt="Book Cover Image">
                                </div>
                                <div class="fm-stories-content">
                                    <div class="fm-st-promt-tag">
                                        <span class="fm-st-ti">Love & Relationship</span>
                                        <div class="fm-question-actions fm-dropdown ms-auto">
                                            <button type="button" class="fm-question-menu-btn" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Open storybook actions">
                                                <img src="images/icons/fm-vertical-dots.svg" class="fm-svg" alt="Actions" />
                                            </button>
                                            <div class="dropdown-menu fm-dropdown-menu">
                                                <a href="#" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-edit-pen.svg" class="fm-svg" alt="Edit" />
                                                    <span class="fm-question-action-label">Edit</span>
                                                </a>
                                                <button type="button" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-delete-bl.svg" class="fm-svg" alt="Delete" />
                                                    <span class="fm-question-action-label">Delete</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <h4 class="fm-head-20 fm-head-sty2 mb-0"><a href="storybook-details.html">Our Wedding Day</a></h4>
                                    <p>A timeless celebration of love and beautiful new beginnings.</p>
                                    <div class="fm-user-profile">
                                        <hr class="my-0" />
                                        <div class="fm-card-btm">
                                            <p class="fm-icon-content">
                                            <img src="images/icons/fm-calendar-green.svg" class="fm-family-icon" alt="Calendar Icon" /> 
                                            February 14, 2024
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 col-xxl-3">
                            <div class="fm-stories-blog fm-match-height">
                                <div class="fm-stories-cover">
                                    <img class="fm-image" src="images/storybooks/bookcover-8.png" alt="Book Cover Image">
                                </div>
                                <div class="fm-stories-content">
                                    <div class="fm-st-promt-tag">
                                        <span class="fm-st-ti">Childhood</span>
                                        <div class="fm-question-actions fm-dropdown ms-auto">
                                            <button type="button" class="fm-question-menu-btn" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Open storybook actions">
                                                <img src="images/icons/fm-vertical-dots.svg" class="fm-svg" alt="Actions" />
                                            </button>
                                            <div class="dropdown-menu fm-dropdown-menu">
                                                <a href="#" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-edit-pen.svg" class="fm-svg" alt="Edit" />
                                                    <span class="fm-question-action-label">Edit</span>
                                                </a>
                                                <button type="button" class="dropdown-item fm-dropdown-item">
                                                    <img src="images/icons/fm-delete-bl.svg" class="fm-svg" alt="Delete" />
                                                    <span class="fm-question-action-label">Delete</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <h4 class="fm-head-20 fm-head-sty2 mb-0"><a href="storybook-details.html">Family & Togetherness</a></h4>
                                    <p>Cherished family moments filled with love and togetherness.</p>
                                    <div class="fm-user-profile">
                                        <hr class="my-0" />
                                        <div class="fm-card-btm">
                                            <p class="fm-icon-content">
                                            <img src="images/icons/fm-calendar-green.svg" class="fm-family-icon" alt="Calendar Icon" /> 
                                            December 25, 2024
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="fm-pagination" aria-label="Storybooks fm-pagination">
                        <ul class="fm-pagination-ul">
                            <li class="fm-page-item">
                                <a href="#" class="fm-page-link fm-page-controller" aria-label="Previous page">
                                    <img src="images/icons/fm-left-ar.svg" class="fm-svg" alt="Previous" />
                                </a>
                            </li>
                            <li class="fm-page-item">
                                <a href="#" class="fm-page-link fm-active" aria-label="Page 1">1</a>
                            </li>
                            <li class="fm-page-item">
                                <a href="#" class="fm-page-link" aria-label="Page 2">2</a>
                            </li>
                            <li class="fm-page-item">
                                <span class="fm-page-link" aria-hidden="true">...</span>
                            </li>
                            <li class="fm-page-item">
                                <a href="#" class="fm-page-link" aria-label="Page 8">8</a>
                            </li>
                            <li class="fm-page-item">
                                <a href="#" class="fm-page-link" aria-label="Page 9">9</a>
                            </li>
                            <li class="fm-page-item">
                                <a href="#" class="fm-page-link fm-page-controller" aria-label="Next page">
                                    <img src="images/icons/fm-right-ar.svg" class="fm-svg" alt="Next" />
                                </a>
                            </li>
                        </ul>
                    </div>
                    <!-- Story Book Section End --> 
                </div>
            </div>
            <!-- Content Wrapper End -->